import { Currency } from '../currencies/types';
import { name as announcement, Announcement } from './Announcement';
import { name as arrow, Arrow } from './Arrow';
import { name as bankID, BankID } from './BankID';
import { name as bell, Bell } from './Bell';
import { name as block, Block } from './Block';
import { name as bomb, Bomb } from './Bomb';
import { name as building, Building } from './Building';
import { name as card, Card } from './Card';
import { name as checkmark, Checkmark } from './Checkmark';
import { name as chevron, Chevron } from './Chevron';
import { name as close, Close } from './Close';
import { name as community, Community } from './Community';
import { name as copy, Copy } from './Copy';
import {
  ADA,
  ALGO,
  BCH,
  BTC,
  DOGE,
  DOT,
  ETH,
  LINK,
  LTC,
  SOL,
  USDT,
  XLM,
  XRP,
  EUR,
  SEK,
  NOK,
  USD,
  USDC,
} from './currencies';
import { name as deposit, Deposit } from './Deposit';
import { name as document, Document } from './Document';
import { name as download, Download } from './Download';
import { name as earn, Earn } from './Earn';
import { name as edit, Edit } from './Edit';
import { name as error, Error } from './Error';
import { name as fb, FB } from './FB';
import { name as filter, Filter } from './Filter';
import { name as flagAT, FlagAT } from './FlagAT';
import { name as flagBE, FlagBE } from './FlagBE';
import { name as flagBG, FlagBG } from './FlagBG';
import { name as flagCY, FlagCY } from './FlagCY';
import { name as flagCZ, FlagCZ } from './FlagCZ';
import { name as flagDE, FlagDE } from './FlagDE';
import { name as flagDK, FlagDK } from './FlagDK';
import { name as flagEE, FlagEE } from './FlagEE';
import { name as flagES, FlagES } from './FlagES';
import { name as flagFI, FlagFI } from './FlagFI';
import { name as flagFR, FlagFR } from './FlagFR';
import { name as flagGB, FlagGB } from './FlagGB';
import { name as flagGR, FlagGR } from './FlagGR';
import { name as flagHR, FlagHR } from './FlagHR';
import { name as flagHU, FlagHU } from './FlagHU';
import { name as flagIE, FlagIE } from './FlagIE';
import { name as flagIS, FlagIS } from './FlagIS';
import { name as flagIT, FlagIT } from './FlagIT';
import { name as flagLI, FlagLI } from './FlagLI';
import { name as flagLT, FlagLT } from './FlagLT';
import { name as flagLU, FlagLU } from './FlagLU';
import { name as flagLV, FlagLV } from './FlagLV';
import { name as flagMT, FlagMT } from './FlagMT';
import { name as flagNL, FlagNL } from './FlagNL';
import { name as flagNO, FlagNO } from './FlagNO';
import { name as flagNR, FlagNR } from './FlagNR';
import { name as flagPL, FlagPL } from './FlagPL';
import { name as flagPT, FlagPT } from './FlagPT';
import { name as flagRO, FlagRO } from './FlagRO';
import { name as flagSE, FlagSE } from './FlagSE';
import { name as flagSI, FlagSI } from './FlagSI';
import { name as flagSK, FlagSK } from './FlagSK';
import { name as flagUS, FlagUS } from './FlagUS';
import { name as freeze, Freeze } from './Freeze';
import { name as hamburger, Hamburger } from './Hamburger';
import { name as help, Help } from './Help';
import { name as home, Home } from './Home';
import { name as info, Info } from './Info';
import { name as instagram, Instagram } from './Instagram';
import { name as list, List } from './List';
import { name as lock, Lock } from './Lock';
import { name as logout, Logout } from './Logout';
import { name as message, Message } from './Message';
import { name as minus, Minus } from './Minus';
import { name as noBankID, NOBankID } from './NOBankID';
import { name as noFunds, NoFunds } from './NoFunds';
import { name as passcode, Passcode } from './Passcode';
import { name as paste, Paste } from './Paste';
import {
  name as paymentMethodCard,
  PaymentMethodCard,
} from './PaymentMethodCard';
import { name as plus, Plus } from './Plus';
import { name as profile, Profile } from './Profile';
import { name as qb, QB } from './QB';
import { name as qr, QR } from './QR';
import { name as receive, Receive } from './Receive';
import { name as scan, Scan } from './Scan';
import { name as search, Search } from './Search';
import { name as security, Security } from './Security';
import { name as send, Send } from './Send';
import { name as settings, Settings } from './Settings';
import { name as snowflake, Snowflake } from './Snowflake';
import { name as spinner, Spinner } from './Spinner';
import { name as stats, Stats } from './Stats';
import { name as support, Support } from './Support';
import { name as swap, Swap } from './Swap';
import { name as switchCurrency, SwitchCurrency } from './SwitchCurrency';
import { name as trash, Trash } from './Trash';
import { name as xTwitter, XTwitter } from './Twitter';
import { name as visibilityOff, VisibilityOff } from './VisibilityOff';
import { name as visibilityOn, VisibilityOn } from './VisibilityOn';
import { name as wallet, Wallet } from './Wallet';

export type IconName =
  | typeof bankID
  | typeof spinner
  | typeof qb
  | typeof help
  | typeof chevron
  | typeof close
  | typeof edit
  | Currency
  | typeof noFunds
  | typeof error
  | typeof info
  | typeof filter
  | typeof lock
  | typeof profile
  | typeof community
  | typeof list
  | typeof settings
  | typeof search
  | typeof send
  | typeof receive
  | typeof plus
  | typeof home
  | typeof visibilityOn
  | typeof visibilityOff
  | typeof building
  | typeof trash
  | typeof flagFI
  | typeof flagGB
  | typeof flagNL
  | typeof flagNO
  | typeof flagNR
  | typeof flagSE
  | typeof flagUS
  | typeof flagAT
  | typeof flagBE
  | typeof flagBG
  | typeof flagHR
  | typeof flagCY
  | typeof flagCZ
  | typeof flagDK
  | typeof flagEE
  | typeof flagFR
  | typeof flagDE
  | typeof flagGR
  | typeof flagHU
  | typeof flagIE
  | typeof flagIS
  | typeof flagIT
  | typeof flagLV
  | typeof flagLI
  | typeof flagLT
  | typeof flagLU
  | typeof flagMT
  | typeof flagPL
  | typeof flagPT
  | typeof flagRO
  | typeof flagSK
  | typeof flagSI
  | typeof flagES
  | typeof hamburger
  | typeof logout
  | typeof document
  | typeof download
  | typeof copy
  | typeof deposit
  | typeof paste
  | typeof scan
  | typeof arrow
  | typeof switchCurrency
  | typeof support
  | typeof paymentMethodCard
  | typeof bell
  | typeof earn
  | typeof checkmark
  | typeof qr
  | typeof minus
  | typeof wallet
  | typeof bomb
  | typeof fb
  | typeof instagram
  | typeof message
  | typeof stats
  | typeof xTwitter
  | typeof announcement
  | typeof swap
  | typeof noBankID
  | typeof security
  | typeof snowflake
  | typeof card
  | typeof freeze
  | typeof passcode
  | typeof block;

export const iconMap: Record<IconName, JSX.Element> = {
  [bankID]: <BankID />,
  [spinner]: <Spinner />,
  [qb]: <QB />,
  [help]: <Help />,
  [chevron]: <Chevron />,
  [close]: <Close />,
  ['ADA']: <ADA />,
  ['ALGO']: <ALGO />,
  ['BCH']: <BCH />,
  ['BTC']: <BTC />,
  ['DOGE']: <DOGE />,
  ['DOT']: <DOT />,
  ['ETH']: <ETH />,
  ['LINK']: <LINK />,
  ['LTC']: <LTC />,
  ['SOL']: <SOL />,
  ['USDT']: <USDT />,
  ['USDC']: <USDC />,
  ['XLM']: <XLM />,
  ['XRP']: <XRP />,
  ['EURQ']: <EUR />,
  ['EUR']: <EUR />,
  ['SEK']: <SEK />,
  ['NOK']: <NOK />,
  ['USD']: <USD />, //No icon for USD so used the flag of US for now 😄
  [noFunds]: <NoFunds />,
  [error]: <Error />,
  [info]: <Info />,
  [filter]: <Filter />,
  [lock]: <Lock />,
  [profile]: <Profile />,
  [community]: <Community />,
  [list]: <List />,
  [settings]: <Settings />,
  [home]: <Home />,
  [search]: <Search />,
  [send]: <Send />,
  [receive]: <Receive />,
  [plus]: <Plus />,
  [visibilityOn]: <VisibilityOn />,
  [visibilityOff]: <VisibilityOff />,
  [building]: <Building />,
  [trash]: <Trash />,
  [flagFI]: <FlagFI />,
  [flagGB]: <FlagGB />,
  [flagNL]: <FlagNL />,
  [flagNO]: <FlagNO />,
  [flagNR]: <FlagNR />,
  [flagSE]: <FlagSE />,
  [flagUS]: <FlagUS />,
  [flagAT]: <FlagAT />,
  [flagBE]: <FlagBE />,
  [flagBG]: <FlagBG />,
  [flagHR]: <FlagHR />,
  [flagCY]: <FlagCY />,
  [flagCZ]: <FlagCZ />,
  [flagDK]: <FlagDK />,
  [flagEE]: <FlagEE />,
  [flagFR]: <FlagFR />,
  [flagDE]: <FlagDE />,
  [flagGR]: <FlagGR />,
  [flagHU]: <FlagHU />,
  [flagIE]: <FlagIE />,
  [flagIS]: <FlagIS />,
  [flagIT]: <FlagIT />,
  [flagLU]: <FlagLU />,
  [flagLI]: <FlagLI />,
  [flagLT]: <FlagLT />,
  [flagLV]: <FlagLV />,
  [flagMT]: <FlagMT />,
  [flagPL]: <FlagPL />,
  [flagPT]: <FlagPT />,
  [flagRO]: <FlagRO />,
  [flagSK]: <FlagSK />,
  [flagSI]: <FlagSI />,
  [flagES]: <FlagES />,
  [hamburger]: <Hamburger />,
  [logout]: <Logout />,
  [document]: <Document />,
  [download]: <Download />,
  [copy]: <Copy />,
  [deposit]: <Deposit />,
  [paste]: <Paste />,
  [scan]: <Scan />,
  [arrow]: <Arrow />,
  [switchCurrency]: <SwitchCurrency />,
  [support]: <Support />,
  [paymentMethodCard]: <PaymentMethodCard />,
  [bell]: <Bell />,
  [earn]: <Earn />,
  [checkmark]: <Checkmark />,
  [qr]: <QR />,
  [minus]: <Minus />,
  [wallet]: <Wallet />,
  [bomb]: <Bomb />,
  [fb]: <FB />,
  [instagram]: <Instagram />,
  [message]: <Message />,
  [stats]: <Stats />,
  [xTwitter]: <XTwitter />,
  [announcement]: <Announcement />,
  [swap]: <Swap />,
  [noBankID]: <NOBankID />,
  [snowflake]: <Snowflake />,
  [edit]: <Edit />,
  [security]: <Security />,
  [card]: <Card />,
  [freeze]: <Freeze />,
  [passcode]: <Passcode />,
  [block]: <Block />,
};
